@import (reference) './packing-applied.module.less';

.packing-applied-label {
  .packing-applied-label-styles();
}

.packing-applied-field {
  position: relative;
}
